import * as React from "react";
export var HomeSaleProductsContext = React.createContext({
  dataSale: null,
  loadingSale: true
});
HomeSaleProductsContext.displayName = "HomeSaleProductsContext";